<template>
<b-modal :id="modalId" title="Uninstall LineSIGHT" size="lg" :no-close-on-backdrop="true" header-bg-variant="dark" header-text-variant="light" body-bg-variant="light"  :no-fade="true"
  @ok="sendUninstallSentinel">
  <b-container fluid>
    <h4 class="card-title">{{ product_serial_num }}</h4>
    <p class="card-text"><strong>Circuit: </strong><span v-if="device && device.pole">{{device.pole.circuit_name}}</span><span v-else>N/A</span></p>
    <p class="card-text"><strong>Substation Number: </strong><span v-if="device && device.pole">{{device.pole.pole_substation_number}}</span><span v-else>N/A</span></p>
  </b-container>
</b-modal>
</template>

<script>
import {
  mapActions
} from 'vuex';

export default {
  name: "UninstallationModal",
  props: {
    device: {
      type: Object
    },
    modalId: {
      type: String,
      required: false,
      default: 'UninstallationModal'
    },
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions('alert', ['success', 'error']),
    ...mapActions('device', ['uninstallDevice']),

    sendUninstallSentinel() {
      this.uninstallDevice(this.device)
      .then(() => {
        this.success("Successfully uninstalled device " + this.device.product_serial_num);
        this.$emit("uninstallSuccess");
        this.$emit("updateCircuit")
      })
      .catch(() => {
          this.error("Error uninstalling device " + this.device.product_serial_num);
      })
      .finally(() => {
        this.$emit("modalReset");
      });
    }
  },
  computed: {
    product_serial_num() {
      if (this.device) {
        return this.device.product_serial_num;
      }
      else {
        return '';
      }
    }
  }
};
</script>

<style src="./UninstallationModal.scss" lang="scss" scoped/>
